import { DeliveryEntityDetailDto, FormatTypeDto } from '@/api/backoffice/clients';

export const formatTypeLabel = (type: FormatTypeDto) => {
    return `${type.code} (${type.name})`;
};

export const deliveryEntityLabel = (detail: DeliveryEntityDetailDto) => {
    return `${detail.code} (${detail.label})`;
};

export const copyDeliveryEntityValues = (from: DeliveryEntityDetailDto, to: DeliveryEntityDetailDto) => {
    if (from?.id === to?.id) {
        to.code = from.code;
        to.label = from.label;
        to.description = from.description;
        to.format = from.format;
        to.crs = from.crs;
        to.model = from.model;
    }
};
